import type { WorkflowFilterStatus } from '@app/shared/types/sf-data'

import { SfLog } from '@app/adapters/logger'
import SFetch from '@app/utils/sfetch'

export async function persistOverviewFilter(
  filter: WorkflowFilterStatus
): Promise<void | null> {
  const url = window.Silverfin.Routes.persist_overview_filter_users_path(
    window.Silverfin.currentFirmId,
    {
      company_id: window.Silverfin.currentCompanyId,
      filter,
    }
  )

  try {
    await SFetch.json(url, { method: 'POST' })
  } catch (e) {
    SfLog.warn('Cannot persist overview filter', {
      extra: { error: e, filter },
    })
  }
}

export async function persistAutoUnprepareOnUnreview(
  value: boolean
): Promise<void> {
  const url =
    window.Silverfin.Routes.update_auto_unprepare_on_unreview_users_path(
      window.Silverfin.currentFirmId,
      { value }
    )

  try {
    await SFetch.json(url, { method: 'POST' })
  } catch (e) {
    SfLog.warn('Cannot persist auto unprepare on unreview preference', {
      extra: { error: e, value },
    })
  }
}

export async function persistInsightsSidepaneOpen(
  value: boolean
): Promise<void> {
  const url = window.Silverfin.Routes.toggle_insights_sidepane_users_path(
    window.Silverfin.currentFirmId,
    { value }
  )

  try {
    await SFetch.json(url, { method: 'POST' })
  } catch (e) {
    SfLog.warn('Cannot persist insights sidepane open preference', {
      extra: { error: e, value },
    })
  }
}

export async function persistReportGraphsDrawerOpen(
  value: boolean
): Promise<void> {
  const url =
    window.Silverfin.Routes.toggle_report_graphs_drawer_open_users_path(
      window.Silverfin.currentFirmId,
      { value }
    )

  try {
    await SFetch.json(url, { method: 'POST' })
  } catch (e) {
    SfLog.warn('Cannot persist report graphs drawer open preference', {
      extra: { error: e, value },
    })
  }
}

export async function persistReportGraphsDrawerWidth(
  value: number
): Promise<void> {
  const url =
    window.Silverfin.Routes.update_report_graphs_drawer_width_users_path(
      window.Silverfin.currentFirmId,
      { value }
    )

  try {
    await SFetch.json(url, { method: 'POST' })
  } catch (e) {
    SfLog.warn('Cannot persist report graphs drawer width preference', {
      extra: { error: e, value },
    })
  }
}
